module.exports = __webpack_public_path__ + "img/menu.1e45f48b.svg";